import { buildHeaderContext } from "./shared/header.shared";
import { getHeaderActions as getDefaultActions } from "./types/header.default";
import { getHeaderActions as getEasyAccessOperatorActions } from "./types/header.easyAccessOperator";
import { getHeaderActions as getType7Actions } from "./types/header.customerType7";

/**
 * Resolves sticky header actions from customer context.
 * Returns array of action descriptors { id, visible, tooltip?, tooltipKey?, ... } in display order.
 * @param {Object} params
 * @param {Object} params.finalCustomer - resolved customer (from auth or localStorage)
 * @param {number} params.finalType - user type
 * @param {boolean} params.isLoggedIn
 * @returns {Array} action definitions for the sticky header
 */
export function resolveStickyHeaderActions({
  finalCustomer = null,
  finalType,
  isLoggedIn,
}) {
  const context = buildHeaderContext({
    finalCustomer,
    finalType,
    isLoggedIn,
  });

  const isServicePartnerCustomer = context.isServicePartnerCustomer;
  const customerType =
    finalCustomer?.customerType ?? finalCustomer?.customer_type ?? null;

  if (context.easyAccessOperator) {
    return getEasyAccessOperatorActions(context);
  }
  if (isServicePartnerCustomer || customerType === 7) {
    return getType7Actions(context);
  }

  return getDefaultActions(context);
}
